import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import { TargetComparisonType } from '../models/indicators/spp/spp-indicator';

@Pipe({
    name: 'targetComparisonOperator',
    standalone: false
})
export class TargetComparisonOperatorPipe implements PipeTransform {
  transform(value: TargetComparisonType): string {
    switch (value) {
      case TargetComparisonType.Equal:
        return '=';
      case TargetComparisonType.LessThan:
          return '<';
      case TargetComparisonType.LessThanOrEqual:
        return '<=';
      case TargetComparisonType.GreaterThan:
        return '>';
      case TargetComparisonType.GreaterThanOrEqual:
        return '>=';
    }
  }
}
